function randomKey(name, church) {
    return name.substring(0, 2).toUpperCase() + church.substring(0, 2).toUpperCase() + Math.floor(Math.random() * 1000) + 1;
}

export default randomKey;